import React, { Component } from 'react';
import { Layout, Tooltip, Modal, Form, Input, Button, message, Row, Col, } from 'antd';
import "./siderPage.scss";
import { messageInfoList, getVerificationCode, operaterChangePassWord, operaterChangePhoneNum } from '@/request/api'
import { getMessageCode } from '@/common/util'
import RemoteApply from "@/pages/remoteApply";
import SystemSetting from "@/pages/systemSetting";
import RemoteConsulation from "@/pages/remoteConsulation";
import TypicalCases from "@/pages/typicalCases";
import Jurisdiction from "@/pages/jurisdiction";
import Statistics from '@/pages/statistics'
import Review from "@/pages/review";
import MessageRemind from '../messageRemind'
import logout from "../../assets/image/logout.png"
import turnPhone from "../../assets/image/turnPhone.png"
import password from "../../assets/image/password.png"
import gohome from "../../assets/image/gohome.png"
import jump from "../../assets/image/jump.png"
import GraphStatistics from '@/pages/graphStatistics'
import CustomSearch from '@/pages/customSearch'
import StatisticsTable from '@/pages/statisticsTable'
import Book from '@/pages/book'
import EleCall from '@/pages/eleCall'
// import FollowMana from '@/pages/followMana'
import ReferralApply from '@/pages/singleReferral/referralApply'
import ReferralConsult from '@/pages/singleReferral/referralConsult'
import MedicalReport from '@/pages/medicalReport'
import OperatorPart from '../../pages/operatorPart';//运营商登录模块
// import MedicalScan from '@/pages/medicalScan'
import { requestErrorLog } from "@/common/util";
const { Content } = Layout;
class siderPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			collapsed: false,
			showKey: false,
			vv: 0,
			commonMsgList: [],
			referralMsgList: [],
			isShowCommonMsgAlert: false,
			isShowReferralMsgAlert: false,
			msgType: ["有新会诊到达消息", "会诊完成消息"],
			msgCode: '3,4',
			applyTabskey: '',
			isOperater: JSON.parse(localStorage.getItem('userInfo')) ? false : true,//是否是运营人员
			visiablePasswordOrPhone: false,//修改密码或者修改手机的modal框是否展示
			loadingPhone: false,//获取手机验证码按钮是否可以点击
		};
	}
	componentDidMount() {
		let undefinedurl = this.props.location.search;
		if (undefinedurl === '') {
			this.props.history.push('/404')
		}
		else {
			if (localStorage.getItem("loginType") === '0') {//医联体账号登陆，发送消息
				this.changeTabMessage()
			}
			this.setState({
				showKey: this.props.location.search.split("=")[1].split("&")[0],
				applyTabskey: this.props.location.search.split("=")[2]
			}, () => {
				//右上角菜单拖动处理
				const container = document.getElementById('layoutContainerForDrag');
				const draggable = document.getElementById('draggable');
				let boxlayerX = 0, boxlayerY = 0;
				this.setState({
					dragWidth: draggable.clientWidth
				})
				draggable.addEventListener('dragstart', (e) => {
					e.dataTransfer.setData('text/plain', ''); // 设置拖拽数据
					boxlayerX = e.layerX;
					boxlayerY = e.layerY;
				});
				container.addEventListener('dragover', (e) => {
					e.preventDefault(); // 阻止默认行为
				});
				container.addEventListener('drop', (e) => {
					e.preventDefault();
					const x = e.clientX - container.getBoundingClientRect().left; // 获取鼠标相对于容器的X坐标
					const y = e.clientY - container.getBoundingClientRect().top; // 获取鼠标相对于容器的Y坐标
					// 限制拖拽范围
					if (x < 0) {
						draggable.style.left = '0px';
					} else if (x > container.offsetWidth - draggable.offsetWidth) {
						draggable.style.left = container.offsetWidth - draggable.offsetWidth+ 'px';
					} else {
						if (x - boxlayerX < 0) {
							draggable.style.left = '0px'
						} else {
							draggable.style.left = x - boxlayerX + 'px';
						}
					}
					if (y < 0) {
						draggable.style.top = '0px';
					} else if (y > container.offsetHeight - draggable.offsetHeight) {
						draggable.style.top = container.offsetHeight - draggable.offsetHeight + 'px';
					} else {
						if (y - boxlayerY < 0) {
							draggable.style.top = '0px'
						} else {
							draggable.style.top = y - boxlayerY + 'px';
						}
					}
				});
			})
		}

	}
	componentWillUnmount() {
		clearInterval(this.timer)
	}
	changeTabMessage = () => {
		let msgCode = getMessageCode()
		if (this.timer) clearInterval(this.timer)
		if (msgCode) {
			this.getMessageFn()
			this.timer = setInterval(() => this.getMessageFn(), 120000)
		} else {
			this.setState({
				isShowCommonMsgAlert: false,
				isShowReferralMsgAlert: false,
				commonMsgList: [],
				referralMsgList: [],
			})
		}
		//切换左侧菜单栏时改变路由的applyTabskey值
		// this.setState({
		// 	applyTabskey: 1
		// })
	}
	//获取未读消息列表
	getMessageFn = () => {
		let msgCode = getMessageCode();
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		let params = {
			Type: "MSG_SELECT", // 消息列表
			USER_UID: userInfo.USER_UID,
			HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
			MSG_CODE: msgCode,
			LANGUAGE_VERSION: "1" // 汉语
		}
		messageInfoList(params).then(res => {
			if (res && res.Status === 1) {
				let result = res.Result;
				let commonMsgList = [];
				let referralMsgList = [];
				result.forEach((item) => {
					let code = Number(item.MSG_CODE);
					if (code === 6 || code === 7) {
						referralMsgList.push(item)
					} else {
						commonMsgList.push(item)
					}
				})
				this.setState({
					commonMsgList,
					referralMsgList,
					isShowReferralMsgAlert: referralMsgList.length > 0,
					isShowCommonMsgAlert: commonMsgList.length > 0,
				})

			} else {
				requestErrorLog('', '获取未读消息报错', 0, true)
			}
		})
	}
	//标记为已读
	markAsRead = (msg_uid_arr) => {
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		if (Object.keys(userInfo).length > 0) {
			let params = {
				Type: "READ_MSG", // 消息列表
				msg_uid_arr,
				HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
				LANGUAGE_VERSION: '1' // 汉语
			}
			messageInfoList(params).then(res => {
				if (res && res.Status === 1) {
					this.changeTabMessage()
				} else {
					requestErrorLog('', '标记已读消息报错', 0, true)
				}
			})
		}
	}

	handleLoginOut = () => {
		window.location.href = "/"
		window.localStorage.removeItem('menuList')
		window.localStorage.removeItem('userInfo')
		window.localStorage.removeItem('token')
	}

	handleClick = (e) => {
		this.setState({
			showKey: e.key
		})
	}

	//关闭普通消息提示框
	handleCloseCommonMsg = (alertAudio) => {
		this.setState({
			isShowCommonMsgAlert: false
		})
		alertAudio.src = '';
	}
	//关闭转诊消息提示框
	handleCloseReferralMsg = (alertAudio) => {
		this.setState({
			isShowReferralMsgAlert: false
		})
		alertAudio.src = '';
	}
	//标记为已读
	markAsReadFn = (message) => {
		let msg_uid_arr = [];
		if (Array.isArray(message)) {
			message.forEach(item => {
				msg_uid_arr.push(item.MSG_UID)
			})
		} else {
			msg_uid_arr.push(message.MSG_UID)
		}

		this.markAsRead(msg_uid_arr)
	}
	goHome = () => {
		this.props.history.push('/pages')
	}
	loginOut = () => {
		
			window.location.href = "/"
			window.localStorage.removeItem('menuList')
			window.localStorage.removeItem('userInfo')
			window.localStorage.removeItem('token')
	}
	operateLoginOut = () => {
		window.location.href = "/"
		window.localStorage.removeItem('token')
		window.localStorage.removeItem('operaterInfo')
	}

	jumpOtherTwo = () => {
		const menuType = JSON.parse(localStorage.getItem('menuList')) || [];
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
		if (menuType.indexOf("动态血压") > -1) {
			this.props.history.push('/siderPage?key=2&applyTabskey=3');
			window.location.reload()
		}
		if (menuType.indexOf("动态心电") > -1) {
			this.props.history.push('/siderPage?key=2&applyTabskey=2');
			window.location.reload()
		}
		if (menuType.indexOf("静息心电") > -1) {
			this.props.history.push('/siderPage?key=2&applyTabskey=1')
			window.location.reload()
		}
		if ((menuType.indexOf("单向转诊") > -1 || userInfo.HOSPITAL_UID === 'PLATFORM') && this.state.showKey === '9') {
			this.props.history.push('/siderPage?key=8')
			window.location.reload()
		}
	}

	jumpOtherSex = () => {
		const menuType = JSON.parse(localStorage.getItem('menuList')) || [];
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
		if (menuType.indexOf("动态血压") > -1) {
			this.props.history.push('/siderPage?key=6&applyTabskey=3');
			window.location.reload()
		}
		if (menuType.indexOf("动态心电") > -1) {
			this.props.history.push('/siderPage?key=6&applyTabskey=2');
			window.location.reload()
		}
		if (menuType.indexOf("静息心电") > -1) {
			this.props.history.push('/siderPage?key=6&applyTabskey=1')
			window.location.reload()
		}
		if ((menuType.indexOf("单向转诊") > -1 || userInfo.HOSPITAL_UID === 'PLATFORM') && this.state.showKey === '8') {
			this.props.history.push('/siderPage?key=9')
			window.location.reload()
		}
	}
	turnPhone = () => {
		this.setState({
			visiablePasswordOrPhone: true,
			changePhoneOrPassWord: 0,//0变更手机号码；1变更密码
		})
	}
	changePassWord = () => {
		this.setState({
			visiablePasswordOrPhone: true,
			changePhoneOrPassWord: 1,//0变更手机号码；1变更密码
		})
	}
	getVerificationCode = async () => {
		let isPhoneNum = true//新手机号格式不对，不让发短信
		this.props.form.validateFields(['newPhone'], (err) => {
			if (err.newPhone) {
				isPhoneNum = false
				message.warn(err.newPhone.errors[0].message)
			}
		});
		if (!isPhoneNum) {
			return
		}
		if (this.props.form.getFieldValue("oldPhone") !== localStorage.getItem('remoteLoginAccount')) {
			message.warn('原手机号码与当前手机号码不一致，请重新输入原手机号码')
			return
		}
		if (this.props.form.getFieldValue("newPhone") === this.props.form.getFieldValue("oldPhone")) {
			message.warn('新手机号码与原手机号码相同，请重新输入新手机号码')
			return
		}
		if (this.props.form.getFieldValue("newPhone") === localStorage.getItem('remoteLoginAccount')) {
			message.warn('新手机号码与当前登录手机号码相同，请重新输入新手机号码')
			return
		}
		let that = this
		//获取验证码
		let Param = {
			Type: "GetVerificationCode",
			TELEPHONE: this.props.form.getFieldValue("newPhone")
		}
		let res = await getVerificationCode(Param)
		let verificationCode = ''
		if (res && res.Status === 1) {
			verificationCode = res.Result
		} else {
			requestErrorLog('', '运营人员登录获取手机号验证码报错', 0, true)
		}
		//计时器
		this.setState({
			loadingPhoneNum: true,
			timer: 59,
			verificationCode,
		}, () => {
			let timer = 59
			let startTimer = setInterval(function () {
				timer--;
				if (timer === 0) {
					clearInterval(startTimer);
					that.setState({
						loadingPhoneNum: false,
						timer: 0
					})
				}
				that.setState({
					timer
				})

			}, 1000)
		})
		setTimeout(() => {
			that.setState({
				verificationCode: ''
			})
		}, 300 * 1000);//5分钟清空验证码

	}
	passWordSubmit = () => {
		const operaterInfo = JSON.parse(localStorage.getItem('operaterInfo')) || {};
		this.props.form.validateFields(async (err, values) => {
			if (!err) {
				if (values.newPassword !== values.confirmNewPassWord) {
					message.warn('两次密码不一致请重新输入')
					return
				} else {
					let Param = {
						Type: "ChangePassWord",
						OPERATION_UID: operaterInfo.OPERATION_UID,
						oldPassWord: values.oldPassword,
						newPassWord: values.newPassword,
					}
					let res = await operaterChangePassWord(Param)
					if (res && res.Status === 1) {
						if (res.Result?.toString() === '2') {
							message.warn('旧密码错误')
						} else {
							message.success('密码修改成功')
							this.setState({
								visiablePasswordOrPhone: false
							})
							this.props.form.resetFields()
						}
					} else {
						requestErrorLog('', '运营人员修改密码报错', 0, true)
					}
				}
			}
		});
	}
	phoneSubmit = () => {
		const operaterInfo = JSON.parse(localStorage.getItem('operaterInfo')) || {};
		this.props.form.validateFields(async (err, values) => {
			if (!err) {
				//判断验证码是否正确
				if (values.newPhone === values.oldPhone) {
					message.warn('新手机号码与原手机号码相同，请重新输入新手机号码')
					return
				}
				if (values.newPhone === localStorage.getItem('remoteLoginAccount')) {
					message.warn('新手机号码与当前登录手机号码相同，请重新输入新手机号码')
					return
				}

				if (values.oldPhone !== localStorage.getItem('remoteLoginAccount')) {
					message.warn('原手机号码与当前手机号码不一致，请重新输入原手机号码')
					return
				}
				if (values.verificationCode !== this.state.verificationCode) {
					message.warn('验证码无效，请重新请求验证码')
					return
				}
				let Param = {
					Type: "ChangePhoneNum",
					OPERATION_UID: operaterInfo.OPERATION_UID,
					OPERATION_PHONE: values.newPhone,
					OLD_OPERATION_PHONE: values.oldPhone
				}
				let res = await operaterChangePhoneNum(Param)
				if (res && res.Status === 1) {
					if (res.Result?.toString() === '2') {
						message.warn("新手机号重复，修改失败！");
						return
					}
					if (res.Result?.toString() === "3") {
						message.warn("原手机号错误，修改失败！");
						return
					}
					//修改手机号
					message.success('修改成功')
					this.setState({
						visiablePasswordOrPhone: false,
						loadingPhoneNum: false,
						timer: 0,
					})
					this.props.form.resetFields();
				} else {
					message.error('修改失败')
					requestErrorLog('', '运营人员修改手机号报错', 0, true)
				}
			}
		});
	}
	handleCancel = () => {
		this.setState({
			visiablePasswordOrPhone: false,
			verificationCode: ''//页面关掉重新请求验证码
		})
		this.props.form.resetFields();
	}
	render() {
		const { showKey, commonMsgList, applyTabskey, referralMsgList, isOperater } = this.state
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
		const menuType = JSON.parse(localStorage.getItem('menuList')) || [];
		const Token = window.localStorage.getItem('token')
		const custService = JSON.parse(localStorage.getItem('QUERY_ALL'));
		const operaterInfo = JSON.parse(localStorage.getItem('operaterInfo')) || {};
		const roleList = JSON.parse(localStorage.getItem('roleList')) || {};;
		const { getFieldDecorator } = this.props.form;
		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 8 },
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 16 },
			},
		};
		if (Token) {
			return (
				<>
					<Layout id='layoutContainerForDrag' className="pageWrap" style={{ width: '100%', height: '100%' }}>
						<Layout style={{ position: 'relative' }}>
							<Content>
								<div className="siderRight">
									{
										isOperater ?
											<div className='currencybutton' id='draggable' draggable="true" style={{ width: this.state.dragWidth }}>
												<div className='move'></div>
												<div onClick={() => this.turnPhone()}>
													<img alt='' src={turnPhone} />
													<p>变更手机</p>
												</div>
												<div onClick={() => this.changePassWord()}>
													<img alt='' src={password} />
													<p>修改密码</p>
												</div>
												<Tooltip title={operaterInfo.OPERATION_NAME}>
													<div onClick={() => this.operateLoginOut()}>
														<img alt='' src={logout} />
														<p className='realName'>{operaterInfo.OPERATION_NAME}</p>
													</div>
												</Tooltip>
											</div> :
											<div style={{ width: this.state.dragWidth }} className='currencybutton' id='draggable' draggable="true">
												<div className='move'></div>
												<div onClick={() => this.goHome()}>
													<img alt='' src={gohome} />
													<p>返回首页</p>
												</div>
												{
													(showKey === '6' || showKey === '9') && menuType.indexOf("远程申请") > -1 ?
														<div onClick={this.jumpOtherTwo}>
															<img alt='' src={jump} />
															<p>跳转申请</p>
														</div>
														: null
												}
												{
													(showKey === '2' || showKey === '8') && menuType.indexOf("远程会诊") > -1 ?
														<div onClick={this.jumpOtherSex}>
															<img alt='' src={jump} />
															<p>跳转会诊</p>
														</div> : null
												}
												<Tooltip title={userInfo.REAL_NAME}>
													<div onClick={() => this.loginOut()}>
														<img alt='' src={logout} />
														<p className='realName'>{userInfo.REAL_NAME}</p>
													</div>
												</Tooltip>
											</div>
									}
									{
										(showKey === '2' && custService === 1) || (showKey === '2' && (menuType.indexOf("远程申请") > -1)) || (showKey === '2' && userInfo.IS_ADMINISTRATOR) ? <RemoteApply history={this.props.history} getMessageFn={this.changeTabMessage} applyTabskey={applyTabskey} /> : null
									}
									{
										(showKey === '6' && menuType.indexOf("远程会诊") > -1) || (showKey === '6' && userInfo.IS_ADMINISTRATOR) ? <RemoteConsulation history={this.props.history} getMessageFn={this.changeTabMessage} applyTabskey={applyTabskey} /> : null
									}
									{
										(showKey === '7' && menuType.indexOf("典型病例") > -1) || (showKey === '7' && userInfo.IS_ADMINISTRATOR) ? <TypicalCases /> : null
									}
									{
										(showKey === '12' && menuType.indexOf("数据统计") > -1) || (showKey === '12' && userInfo.IS_ADMINISTRATOR) ? <Statistics /> : null
									}
									{
										(showKey === '13' && roleList.indexOf('二级管理员') > -1) || (showKey === '13' && userInfo.IS_ADMINISTRATOR) ? <Jurisdiction /> : null
									}
									{
										(showKey === '14' && menuType.indexOf("系统配置") > -1) || (showKey === '14' && userInfo.IS_ADMINISTRATOR) ? <SystemSetting getMessageFn={this.changeTabMessage} /> : null
									}
									{
										(showKey === '15' && menuType.indexOf("质量控制") > -1) || (showKey === '15' && userInfo.IS_ADMINISTRATOR) ? <Review /> : null
									}
									{
										showKey === '16' ? <GraphStatistics /> : null
									}
									{
										showKey === '17' ? <CustomSearch /> : null
									}
									{
										showKey === '18' ? <StatisticsTable /> : null
									}
									{
										showKey === '1' ? <Book /> : null
									}
									{
										showKey === '3' ? <EleCall /> : null
									}
									{
										showKey === '8' ? <ReferralApply history={this.props.history} /> : null
									}
									{
										showKey === '9' ? <ReferralConsult /> : null
									}

									{
										showKey === '4' ? <MedicalReport /> : null
									}


									{
										showKey === '19' ? <OperatorPart /> : null
									}
									{/* {
										showKey === '4' ? <MedicalScan /> : null
									} */}
								</div>
							</Content>
						</Layout>
					</Layout>

					<div className="messageAlertBox">
						{this.state.isShowReferralMsgAlert ?
							<MessageRemind
								messageAlertList={referralMsgList}
								visiablePasswordOrPhone={this.state.isShowReferralMsgAlert}
								handleCloseMsg={this.handleCloseReferralMsg}
								markAsReadFn={this.markAsReadFn}
								className="referralNotification"
								title='转诊---新消息'
								isShowMessageAlert={this.state.isShowReferralMsgAlert}
							/> : null
						}
						{this.state.isShowCommonMsgAlert ?
							<MessageRemind
								messageAlertList={commonMsgList}
								className="commonNotification"
								title='会诊---新消息'
								visiablePasswordOrPhone={this.state.isShowCommonMsgAlert}
								handleCloseMsg={this.handleCloseCommonMsg}
								markAsReadFn={this.markAsReadFn}
								isShowMessageAlert={this.state.isShowCommonMsgAlert}
							/> : null
						}
					</div>

					<Modal
						title={
							<div className="patient_title">
								<img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
								<span>{this.state.changePhoneOrPassWord ? "修改密码" : '修改手机号码'}</span>
							</div>
						}
						visible={this.state.visiablePasswordOrPhone}
						maskClosable={false}
						onOk={this.state.changePhoneOrPassWord ? this.passWordSubmit : this.phoneSubmit}
						onCancel={this.handleCancel}
						width={500}
						height={300}>
						{
							this.state.changePhoneOrPassWord ?
								<Form onSubmit={this.passWordSubmit} className="login-form" {...formItemLayout}>
									<Form.Item label="旧密码" >
										{getFieldDecorator('oldPassword', {
											rules: [
												{
													required: true,
													message: '请输入旧密码!',
												},
											],
										})(<Input.Password />)}
									</Form.Item>
									<Form.Item label="新密码" >
										{getFieldDecorator('newPassword', {
											rules: [
												{
													required: true,
													message: '请输入新密码!',
												},
											],
										})(<Input.Password />)}
									</Form.Item>
									<Form.Item label="确认密码" >
										{getFieldDecorator('confirmNewPassWord', {
											rules: [
												{
													required: true,
													message: '确认新密码!',
												}
											],
										})(<Input.Password />)}
									</Form.Item>
								</Form> :
								<Form onSubmit={this.phoneSubmit} className="login-form" {...formItemLayout}>
									<Form.Item label="原手机号码" >
										{getFieldDecorator('oldPhone', {
											rules: [
												{
													required: true,
													message: '请输入原手机号码!',
												}, { message: "请输入正确的手机号！", pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ }
											],
										})(<Input />)}
									</Form.Item>
									<Form.Item label="新手机号码" >
										{getFieldDecorator('newPhone', {
											rules: [
												{
													required: true,
													message: '请输入新手机号码!',
												}, { message: "请输入正确的手机号！", pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ }
											],
										})(<Input />)}
									</Form.Item>
									<Form.Item label="短信验证码" >
										<Row gutter={8}>
											<Col span={14}>
												{getFieldDecorator('verificationCode', {
													rules: [
														{
															required: true,
															message: '确认短信验证码!',
														}
													],
												})(<Input />)}
											</Col>
											<Col span={2}>
												{
													this.state.loadingPhoneNum ? <p style={{ width: '150px', color: '#009d96' }}>{this.state.timer + 's后重新获取'}</p> : <Button className="loadButton" onClick={this.getVerificationCode}>获取验证码</Button>
												}

											</Col>
										</Row>
									</Form.Item>
								</Form>
						}
					</Modal>
				</>
			)
		}
	}
}
export default Form.create({})(siderPage);